module.exports = __webpack_public_path__ + "static/media/lecturer7.21d33998.jpg";